import firebase from '@/firebase.config'
import firestore from './firestore'

export default {
  state: () => ({
    user: {
      loggedIn: false,
      id: null,
      isAdmin: false,

      path: null,
      data: {}
    }
  }),
  getters: {
    user(state) {
      return state.user
    }
  },
  mutations: {
    SET_INITIAL_USER(state, { id, isAdmin, path, data }) {
      state.user.loggedIn = true
      state.user.id = id
      state.user.isAdmin = isAdmin
      state.user.path = path
      state.user.data = data
    },
    UPDATE_USER(state, user) {
      state.user.data = user.data
    },
    RESET_USER(state) {
      state.user.loggedIn = false
      state.user.id = null
      state.user.isAdmin = null
      state.user.path = null
      state.user.data = {}
    }
  },
  actions: {
    async storeAuthUser({ commit }, { authUser, userData }) {
      // Check if they are an admin
      const idTokenResult = await authUser.getIdTokenResult()
      commit("SET_INITIAL_USER", {
        id: authUser.uid,
        isAdmin: idTokenResult.claims.admin,
        path: 'users/'+authUser.uid,
        data: userData
      })
    },
    async bindUserData({ commit, getters }) {
      // TODO: REMOVE LEGACY SUPPORT AFTER 1/11/2020
      // Check if there is a legacy data structure and convert it
      if (Object.prototype.hasOwnProperty.call(getters.user.data, 'id')) {
        commit("SET_INITIAL_USER", {
          id: getters.user.data.id,
          isAdmin: false,
          path: 'users/' + getters.user.data.id,
          data: {
            userType: getters.user.data.isLecturer ? 'LECTURER' : 'STUDENT'
          }
        })
      }

      // Only allow this binding to be created once
      if (!getters.singletonGuards.includes('USER_BIND')) {
        commit('ADD_SINGLETON_GUARD', 'USER_BIND')

        let userRef = firebase.firestore().collection('users').doc(getters.user.id)

        const unbindFunction = await userRef.onSnapshot(doc => {
          const user = firestore.doc2data(doc)
          commit("UPDATE_USER", user)
        })
        commit('ADD_UNBIND_FUNCTION', unbindFunction)
      }
    },
    async updateUser({ getters }, user) {
      await getters.db.doc(user.path).set(user.data)
    },
    clearAuthUser({ commit }) {
      commit('UNBIND_FIRESTORE_FUNCTIONS')
      commit('RESET_FIRESTORE_STATE')
      commit('CLEAR_SINGLETON_GUARDS')
      commit("RESET_USER")
    }
  }
}
